// RN014: no fluxo antigo (token na URL) modulosAtivos é undefined — sem restrição, libera tudo.
// Numa sessão de portal, só libera se o módulo estiver entre os liberados para o cliente ativo.
export function temModulo(modulosAtivos, nomeModulo) {
    if (!Array.isArray(modulosAtivos)) {
        return true;
    }
    return modulosAtivos.some((modulo) => (modulo.nmModulo || "").toLowerCase() === nomeModulo.toLowerCase());
}
